module.exports = __webpack_public_path__ + "img/MW.7731d349.svg";